require('../../modules/es7.string.pad-end');
module.exports = require('../../modules/_core').String.padEnd;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/pad-end.js
// module id = 1216
// module chunks = 0